import React from "react";
import OrgPortrait from "../assets/world-health.png";
import styles from "../modals/ResourceViewerModal.module.css";

const OrganizationCardExtended = ({ resource }) => {
  //console.log(resource.name);

  const name = resource.name || "Unnamed Organization";
  const address = resource.address?.[0];
  const telecom = resource.telecom || [];
  const type = resource.type?.[0];
  const typeDisplay = type?.text || type?.coding?.[0]?.display || "Unknown";
  const geo = address?.extension?.find(e => e.url.includes("geolocation"))?.extension || [];

  const fullAddress = address
    ? `${address.line?.join(", ")}, ${address.city}, ${address.state} ${address.postalCode}, ${address.country}`
    : null;

  return (
    <div className="p-4 border rounded shadow-sm bg-white">
      {/* Header with Name and Portrait */}
      <div className="d-flex align-items-start mb-4">
        <div style={{ width: "120px", height: "120px", marginRight: "1rem", flexShrink: 0 }}>
          <img
            src={OrgPortrait}
            alt="Organization Portrait"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #ccc",
              backgroundColor: "#f8f9fa"
            }}
          />
        </div>
        <div>
          <h3 className="mb-1">{name}</h3>
          <div className="mb-1 text-muted"><strong>Organization ID:</strong> {resource.id}</div>
          <div className="mb-1 text-muted"><strong>Type:</strong> {typeDisplay}</div>
          <div className="mb-1 text-muted"><strong>Status:</strong> {resource.active ? "Active" : "Inactive"}</div>
        </div>
      </div>

      {/* Section: Identifiers */}
      <div className={styles.sectionHeader}>Identifiers</div>
      <div className={styles.indented}>
        {resource.identifier?.map((id, idx) => (
          <div key={idx} className="mb-1">
            <strong>{id.system || "Identifier"}:</strong> {id.value}
          </div>
        ))}
      </div>

      {/* Section: Contact */}
      <div className={styles.sectionHeader}>Contact</div>
       <div className={styles.indented}>
        {telecom.map((t, idx) => (
          <div key={idx} className="mb-1">
            <strong>{t.system}:</strong> {t.value}
          </div>
        ))}
      </div>

      {/* Section: Location */}
      <div className={styles.sectionHeader}>Location</div>
      <div className={styles.indented}>
        {address && (
          <>
            <div className="mb-1">
              <strong>Address:</strong> {fullAddress}
              {geo.length > 0 && (
                <span className="text-muted">
                  {" "} (Lat: {geo.find(e => e.url === "latitude")?.valueDecimal}, Lon: {geo.find(e => e.url === "longitude")?.valueDecimal})
                </span>
              )}
            </div>
            <div className="mb-1">
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OrganizationCardExtended;